import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { AuthenticationService, EndpointService } from '@app/core';
import { ObservacioneExpediente } from '@app/shared';

@Injectable()
export class ObservationProcessDataService {
  constructor(
    private http: HttpClient,
    private toastr: ToastrService,
    private api: EndpointService,
    private as: AuthenticationService,
  ) {}

  /**
   * Consulta las observaciones de un expediente
   *
   * @returns {Observable<ObservacioneExpediente[]>}
   * @memberof ObservationProcessDataService
   */
  getObservations(process: number): Observable<ObservacioneExpediente[]> {
    return new Observable(obs => {
      this.http.get<ObservacioneExpediente[]>(this.api.get('observationProcess', [process])).subscribe(
        observations => {
          const credentials = this.as.getCredentials();
          observations.forEach((observation) => {
            const dt = new Date(observation.fecha);
            observation.fecha = dt.toLocaleString('en-CO');
            observation.responsableCompleto = observation.responsable.nombre + ' ' + observation.responsable.apellido;
            if (observation.responsable.id === credentials.user_id) {
              observation['delete'] = true;
              observation['update'] = true;
            } else {
              observation['delete'] = false;
              observation['update'] = false;
            }
          });
          obs.next(observations);
        },
        err => {
          obs.error(err);
        }
      );
    });
  }

  /**
   * Agrega una observación a un expediente
   *
   * @param {number} process
   * @param {string} observation
   * @returns {Observable<boolean>}
   * @memberof ObservationProcessDataService
   */
  addObservationProcess(process: number, observation: string): Promise<boolean> {
    let configData: any;
    configData = {
      expediente: process,
      observacion: observation
    };
    return new Promise((resolve, reject) => {
      this.http
        .post(this.api.get('observationProcess'), configData)
        .subscribe(
          _res => {
            resolve(true);
            this.toastr.success('Observación agregada correctamente.', 'Operación exitosa');
          },
          err => {
            reject(err);
          }
        );
    });
  }

  /**
   * Actualiza la observacion de un expediente
   *
   * @param {number} idObservation
   * @param {string} observation
   * @returns {Observable<boolean>}
   * @memberof ObservationProcessDataService
   */
  updateObservationProcess(idObservation: number, observation: string): Promise<boolean> {
    let configData: any;
    configData = {
      observacion: observation
    };
    return new Promise((resolve, reject) => {
      this.http
        .put(this.api.get('observationProcess', [idObservation]), configData)
        .subscribe(
          _res => {
            resolve(true);
            this.toastr.success('Observación actualizada correctamente.', 'Operación exitosa');
          },
          err => {
            reject(err);
          }
        );
    });
  }

  /**
   * Elimina la observacion de un expediente
   *
   * @param {number} idObservation
   * @returns {Observable<boolean>}
   * @memberof ObservationProcessDataService
   */
  deleteObservationProcess(idObservation: number): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.http
        .delete(this.api.get('observationProcess', [idObservation]))
        .subscribe(
          _res => {
            resolve(true);
            this.toastr.success('Observación eliminada correctamente.', 'Operación exitosa');
          },
          err => {
            reject(err);
          }
        );
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/observation-process/shared/observation-process.data.service.ts